import { isEmpty } from 'ramda'
import $t from '../../../../i18n'

const validateDOB = date => {
  let currentYear = new Date().getFullYear()
  let year = new Date(date).getFullYear()
  if (!date) {
    return $t('pages.getStarted.signupForm.errors.pleaseInputDOB')
  } else if (
    year.toString().length < 4 ||
    year < currentYear - 121 ||
    year > currentYear
  ) {
    return $t('pages.getStarted.signupForm.errors.invalidDOB')
  } else {
    return
  }
}

export const getValidationErrors = ({
  isPPF,
  isGifting,
  phoneNumber,
  email,
  confirmEmail,
  firstName,
  lastName,
  state,
  isPayNow,
  dob,
  giftRecipientFirstName,
  giftRecipientLastName,
  giftRecipientEmail,
  giftRecipientConfirmEmail,
  giftRecipientPhoneNo,
}) => {
  const result = {}
  const numericRegex = /^\d{10}$/
  if (isPPF) {
    if (!isGifting && dob) {
      let res = validateDOB(dob)
      if (res) {
        result.dob = validateDOB(dob)
      }
    }
    if (!firstName) {
      result.firstName = $t('errors.validation.missing')
    }
    if (!lastName) {
      result.lastName = $t('errors.validation.missing')
    }

    if (!phoneNumber) {
      result.phoneNumber = $t('errors.validation.missing')
    }
    if (!phoneNumber.match(numericRegex)) {
      result.phoneNumber = $t('errors.validation.invalidPhone')
    }
    if (
      !email ||
      !email
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      result.email = $t('pages.getStarted.invalidEmail')
    }

    if (
      !confirmEmail ||
      !confirmEmail
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      result.confirmEmail = $t('pages.getStarted.invalidEmail')
    }

    if (email !== confirmEmail) {
      result.confirmEmail = $t('pages.paymentplan.confirmEmailError')
    }

    if (!isGifting && !state) {
      result.state = $t('errors.validation.missing')
    }
    if (isPayNow !== true && isPayNow !== false) {
      result.isPayNow = $t('errors.validation.paymentUnselected')
    }
  }
  if (isGifting) {
    if (!giftRecipientFirstName) {
      result.giftRecipientFirstName = $t('errors.validation.missing')
    }
    if (!giftRecipientLastName) {
      result.giftRecipientLastName = $t('errors.validation.missing')
    }
    if (
      !giftRecipientEmail ||
      !giftRecipientEmail
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      result.giftRecipientEmail = $t('pages.getStarted.invalidEmail')
    }

    if (
      !giftRecipientConfirmEmail ||
      !giftRecipientConfirmEmail
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      result.giftRecipientConfirmEmail = $t('pages.getStarted.invalidEmail')
    }

    if (giftRecipientEmail !== giftRecipientConfirmEmail) {
      result.giftRecipientConfirmEmail = $t(
        'pages.paymentplan.confirmEmailError'
      )
    }
    if (!giftRecipientPhoneNo) {
      result.giftRecipientPhone = $t('errors.validation.missing')
    }
    if (!giftRecipientPhoneNo.match(numericRegex)) {
      result.giftRecipientPhone = $t('errors.validation.invalidPhone')
    }

    if (!firstName) {
      result.firstName = $t('errors.validation.missing')
    }
    if (!lastName) {
      result.lastName = $t('errors.validation.missing')
    }

    if (!phoneNumber) {
      result.phoneNumber = $t('errors.validation.missing')
    }
    if (!phoneNumber.match(numericRegex)) {
      result.phoneNumber = $t('errors.validation.invalidPhone')
    }
    if (
      !email ||
      !email
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      result.email = $t('pages.getStarted.invalidEmail')
    }

    if (
      !confirmEmail ||
      !confirmEmail
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      result.confirmEmail = $t('pages.getStarted.invalidEmail')
    }

    if (email !== confirmEmail) {
      result.confirmEmail = $t('pages.paymentplan.confirmEmailError')
    }

    if (!isGifting && !state) {
      result.state = $t('errors.validation.missing')
    }
    if (isPayNow !== true && isPayNow !== false) {
      result.isPayNow = $t('errors.validation.paymentUnselected')
    }
  }
  if (!isPPF && !isGifting) {
    if (!firstName) {
      result.firstName = $t('errors.validation.missing')
    }
    if (!lastName) {
      result.lastName = $t('errors.validation.missing')
    }

    if (!phoneNumber) {
      result.phoneNumber = $t('errors.validation.missing')
    }
    if (!phoneNumber.match(numericRegex)) {
      result.phoneNumber = $t('errors.validation.invalidPhone')
    }
    if (
      !email ||
      !email
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      result.email = $t('pages.getStarted.invalidEmail')
    }

    if (
      !confirmEmail ||
      !confirmEmail
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      result.confirmEmail = $t('pages.getStarted.invalidEmail')
    }

    if (email !== confirmEmail) {
      result.confirmEmail = $t('pages.paymentplan.confirmEmailError')
    }

    if (!isGifting && !state) {
      result.state = $t('errors.validation.missing')
    }
    if (isPayNow !== true && isPayNow !== false) {
      result.isPayNow = $t('errors.validation.paymentUnselected')
    }
  }
  return (!isEmpty(result) && result) || null
}
